module.exports = __webpack_public_path__ + "img/main.e01f0dc3.jpg";